import { defineComponent as _defineComponent } from 'vue'
import { useContext, useRoute } from '@nuxtjs/composition-api';
import PublicPortfolioPostsListSectionWarRoomPostPresenter from './PublicPortfolioPostsListSectionWarRoomPostPresenter.vue';
import { gqlVotableTypes } from '@/components/partials/war-room/constants';
import CreateRatingMutation from '~/apollo/mutations/WarRoom/CreateRating.mutation';
import DestroyRatingMutation from '~/apollo/mutations/WarRoom/DestroyRating.mutation';
import PublicPortfolioPostsQuery from '~/apollo/queries/PublicPortfolio/PublicPortfolioPosts.query';
import type { Post, Query } from '~/types/graphql';

type PublicPortfolioPostsListSectionWarRoomPostPreviewProps = {
  post: Post;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioPostsListSectionWarRoomPostPreview',
  props: {
    post: null
  },
  setup(__props: any) {

const props = __props as {
  post: Post;
};


const { $analytics, app, $notice, $sentryUtils } = useContext();
const route = useRoute();

async function handleAddVote(value: number): Promise<void> {
  $analytics?.logEvent(`public-portfolio__post__rating__set`, { value });
  try {
    await app.apolloProvider?.defaultClient.mutate({
      mutation: CreateRatingMutation,
      variables: {
        input: {
          reactableId: props.post.id,
          reactableType: gqlVotableTypes.POST,
          value,
        },
      },
      update: (cache, { data: { createRating } }) => {
        const variables = {
          slug: route.value.params.slug,
          first: 5,
        };
        const query: Query | null = cache.readQuery({ query: PublicPortfolioPostsQuery, variables });
        const post: Post | undefined = query?.userPublicPosts?.nodes?.find(el => el.id === props.post.id);
        if (!post) return;

        post.currentUserRating = createRating;
        post.totalRating += createRating.value;
        cache.writeQuery({ query: PublicPortfolioPostsQuery, variables, data: query });
      },
    });
  } catch (e) {
    $notice.error(e);
    $sentryUtils.error(e);
  }
}

async function handleRemoveVote(): Promise<void> {
  $analytics?.logEvent(`public-portfolio__post__rating__unset`);
  try {
    await app.apolloProvider?.defaultClient.mutate({
      mutation: DestroyRatingMutation,
      variables: {
        input: {
          reactableId: props.post.id,
          reactableType: gqlVotableTypes.POST,
        },
      },
      update: (cache, { data: { destroyRating } }) => {
        const variables = {
          slug: this.$route.params.slug,
          first: 5,
        };
        const query: Query | null = cache.readQuery({ query: PublicPortfolioPostsQuery, variables });
        const post: Post | undefined = query?.userPublicPosts?.nodes?.find(el => el.id === props.post.id);
        if (!post) return;

        post.currentUserRating = null;
        post.totalRating -= destroyRating.value;
        cache.writeQuery({ query: PublicPortfolioPostsQuery, variables, data: query });
      },
    });
  } catch (e) {
    $notice.error(e);
    $sentryUtils.error(e);
  }
}

return { __sfc: true,props, $analytics, app, $notice, $sentryUtils, route, handleAddVote, handleRemoveVote, PublicPortfolioPostsListSectionWarRoomPostPresenter }
}

})